type GenerateReportPdfOptions = {
	filename: string;
};

const PdfPageWidthMm = 210;
const PdfMarginMm = 10;
const PxPerMm = 96 / 25.4;
const ReportWidthPx = Math.floor((PdfPageWidthMm - PdfMarginMm * 2) * PxPerMm);

function createReportElement(html: string) {
	const parsedDocument = new DOMParser().parseFromString(html, "text/html");
	const reportElement = document.createElement("div");

	Array.from(parsedDocument.head.querySelectorAll("style, link[rel='stylesheet']")).forEach((node) => {
		reportElement.appendChild(node.cloneNode(true));
	});

	reportElement.insertAdjacentHTML("beforeend", parsedDocument.body.innerHTML || html);
	reportElement.style.background = "#ffffff";
	reportElement.style.color = "#000000";
	reportElement.style.width = `${ReportWidthPx}px`;
	reportElement.style.maxWidth = `${ReportWidthPx}px`;
	reportElement.style.boxSizing = "border-box";

	return reportElement;
}

function createHiddenWrapper(reportElement: HTMLElement) {
	const wrapper = document.createElement("div");

	wrapper.style.position = "fixed";
	wrapper.style.left = "-10000px";
	wrapper.style.top = "0";
	wrapper.style.width = `${ReportWidthPx}px`;
	wrapper.style.background = "#ffffff";
	wrapper.appendChild(reportElement);
	document.body.appendChild(wrapper);

	return wrapper;
}

async function waitForReportAssets(element: HTMLElement) {
	const images = Array.from(element.querySelectorAll("img"));

	await Promise.all(
		images.map((image) => {
			if (image.complete) {
				return Promise.resolve();
			}

			return new Promise<void>((resolve) => {
				image.onload = () => resolve();
				image.onerror = () => resolve();
			});
		})
	);

	if (document.fonts?.ready) {
		await document.fonts.ready;
	}
}

export async function generateReportPdfFromHtml(html: string, options: GenerateReportPdfOptions) {
	const reportElement = createReportElement(html);
	const wrapper = createHiddenWrapper(reportElement);

	try {
		await waitForReportAssets(reportElement);

		const html2pdf = (await import("html2pdf.js/dist/html2pdf.bundle.min.js")).default;
		await html2pdf()
			.set({
				margin: [10, 10, 10, 10],
				filename: options.filename,
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff", windowWidth: ReportWidthPx },
				jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
				pagebreak: { mode: ["css", "legacy"], avoid: ["img", "table", "tr"] },
			} as any)
			.from(reportElement)
			.save();
	} finally {
		wrapper.remove();
	}
}
